import { lazy } from "react";
import { withPageLoader } from "@tecorien/mimic";
import { links } from "links";
import { getCreatePathTemplate, getEntityPathTemplate } from "navigation";
import { Permissions } from "permissions";
import { RouteDescription } from "types";

const TagCategoryListPage = lazy(() => import("./TagCategoryListPage"));
const TagCategoryPage = lazy(() => import("./TagCategoryPage"));

export const tagCategoriesRoutes: RouteDescription[] = [
  {
    path: links.tagCategory,
    element: withPageLoader(<TagCategoryListPage />),
    breadcrumb: "Tag categories",
    menuItem: {
      id: "tagCategories",
      label: "Tag categories",
    },
    requiredOneOfPermissions: [ Permissions.SuperAdmin ]
  },
  {
    path: getCreatePathTemplate(links.tagCategory),
    element: withPageLoader(<TagCategoryPage />),
    breadcrumb: "Create new tag category",
    requiredOneOfPermissions: [ Permissions.SuperAdmin ]
  },
  {
    path: getEntityPathTemplate(links.tagCategory),
    element: withPageLoader(<TagCategoryPage />),
    breadcrumb: "Tag category",
    requiredOneOfPermissions: [ Permissions.SuperAdmin ]
  },
];

